const footerLinks = [
  { href: "#address", label: "最新地址" },
  { href: "#troubleshoot", label: "打不开怎么办" },
  { href: "#official", label: "官网入口" },
  { href: "#app", label: "App 下载" },
  { href: "#backup", label: "备用方案" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg">八戒影院</span>
            </div>
            <p className="mt-4 text-xs md:text-sm leading-relaxed text-background-50/65 max-w-sm">
              一个专注于整理最新地址、官方网址入口与访问问题的信息页。
              内容持续更新，帮助你在域名变动时快速找回可用入口。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50/80">快速导航</h4>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs md:text-sm text-background-50/65 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50/80">使用提醒</h4>
            <ul className="mt-4 space-y-2">
              <li className="flex items-start gap-2 text-xs md:text-sm text-background-50/65">
                <i className="ri-shield-check-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                请仅从官方渠道获取地址
              </li>
              <li className="flex items-start gap-2 text-xs md:text-sm text-background-50/65">
                <i className="ri-shield-check-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                不要在可疑页面填写账号信息
              </li>
              <li className="flex items-start gap-2 text-xs md:text-sm text-background-50/65">
                <i className="ri-shield-check-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                本页仅提供信息整理，不提供内容托管
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/55">
            本站内容仅为信息汇总，具体入口请以官方公告为准。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-2 text-xs text-background-50/70 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap"
          >
            返回顶部
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}